import { useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";

const services = [
  {
    icon: "ri-film-line",
    title: "影视资源分享",
    desc: "持续整理电影、电视剧、综艺与纪录片信息，按类型、地区、年份分类，方便快速浏览。",
  },
  {
    icon: "ri-newspaper-line",
    title: "影视资讯更新",
    desc: "追踪行业动态、首映与颁奖、票房数据与幕后故事，每日带来值得阅读的影视内容。",
  },
  {
    icon: "ri-star-line",
    title: "深度影评与推荐",
    desc: "以客观视角解读作品，提供观影参考与个性化推荐，帮你找到真正想看的那一部。",
  },
  {
    icon: "ri-heart-line",
    title: "本地收藏体验",
    desc: "在详情页一键收藏感兴趣的作品，收藏状态保存在你的设备本地，随时回顾。",
  },
];

export default function About() {
  useEffect(() => {
    document.title = "关于我们 - 泡泡影视";
  }, []);

  return (
    <div className="w-full px-4 md:px-8 pt-6">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <div className="mt-5 rounded-xl bg-primary-950 px-6 py-10 md:px-12 md:py-14">
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
          关于泡泡影视
        </h1>
        <p className="mt-4 text-sm md:text-base text-background-300 max-w-3xl leading-8">
          泡泡影视诞生于一群影迷的日常困扰：想找一部好片，却总要在碎片化的信息里翻找太久。我们希望通过清晰的分类、及时的资讯与真诚的推荐，让“找内容”这件事变得轻松而愉快。
        </p>
      </div>

      <section className="mt-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          我们提供什么
        </h2>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950">使用说明</h2>
          <ul className="mt-4 space-y-4 text-sm md:text-base text-foreground-700 leading-7">
            <li className="flex gap-3">
              <i className="ri-check-line text-primary-600 text-lg mt-0.5" />
              <span>本站所有影视与资讯内容均为演示数据，用于展示内容浏览与检索体验。</span>
            </li>
            <li className="flex gap-3">
              <i className="ri-check-line text-primary-600 text-lg mt-0.5" />
              <span>搜索、分类筛选与排序均为前端即时演示，结果实时更新，无需等待。</span>
            </li>
            <li className="flex gap-3">
              <i className="ri-check-line text-primary-600 text-lg mt-0.5" />
              <span>收藏功能保存在你的浏览器本地，更换设备或清除浏览器数据后收藏会重置。</span>
            </li>
            <li className="flex gap-3">
              <i className="ri-close-line text-foreground-400 text-lg mt-0.5" />
              <span>本站不提供影片播放、下载、票务及任何支付服务，请通过正规渠道观看授权内容。</span>
            </li>
          </ul>

          <h2 className="mt-8 font-heading text-xl font-bold text-foreground-950">版权声明</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-700 leading-8">
            本站页面中的影片海报、剧照与资讯配图均为演示用途的示意图，相关名称与信息为虚构示例，仅用于展示产品形态。若涉及版权问题，请通过下方联系方式与我们沟通，我们将第一时间处理。
          </p>
        </div>

        <div className="lg:col-span-1">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <h2 className="font-heading text-xl font-bold text-foreground-950">联系我们</h2>
            <ul className="mt-4 space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-background-50 border border-background-200 text-primary-700 flex items-center justify-center">
                  <i className="ri-mail-line text-lg" />
                </span>
                <span className="text-foreground-800">hello@bubble-movie.com</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-background-50 border border-background-200 text-primary-700 flex items-center justify-center">
                  <i className="ri-wechat-line text-lg" />
                </span>
                <span className="text-foreground-800">微信公众号：泡泡影视</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-background-50 border border-background-200 text-primary-700 flex items-center justify-center">
                  <i className="ri-weibo-line text-lg" />
                </span>
                <span className="text-foreground-800">微博：@泡泡影视官方</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-background-50 border border-background-200 text-primary-700 flex items-center justify-center">
                  <i className="ri-time-line text-lg" />
                </span>
                <span className="text-foreground-800">合作与反馈：工作日 10:00 - 18:00</span>
              </li>
            </ul>

            <Link
              to="/category"
              className="mt-6 flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              开始浏览影视分类
              <i className="ri-arrow-right-line text-lg" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}